import React, {Component} from 'react';

class tab extends Component {
	constructor(props) {
		super(props);

		this.state = {
			ActiveTabMenu: this.props.activeID
		}
	}

	tabClick = (id, event) => {
		event.preventDefault();

		this.props.changeTab(id)
		this.setState({ActiveTabMenu: id})
	}

	render() {
		return (
			<ul className="nav nav-tabs nav-pillsx">
				{Object.keys(this.props.tabList).map((v, idx) => {
					return (
						<li
							key={idx}
							className="nav-item mb-0"
							onClick={(e) => this.tabClick(v, e)}>
							<a className={`nav-link ${this.state.ActiveTabMenu == v ? " active font-weight-bold" : ""}`}
							   href="">
								{this.props.tabList[v]}
							</a>
						</li>
					);
				})}
			</ul>
		)
	}
}

export default tab;
